import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class DeckPlanBehaviour extends AbstractDataAttributeBehaviour {
    attrNames = {
        'container': 'data-deckplan',
        'cabinName': 'data-deckplan-cabin-name',
        'deckName': 'data-deckplan-name',
        'deckCode': 'data-deckplan-deck',
        'colour': 'data-deckplan-colour',
        'textColour': 'data-deckplan-text-colour',
        'price': 'data-deckplan-price',
        'image': 'data-deckplan-image'
    };

    scrollPos = window.scrollY;

    getContainerSelector() {
        return '[' + this.attrNames.container + ']';
    }

    createModal(modalContent){
        let modalShroud = document.createElement("div");
        modalShroud.setAttribute('class', 'modal-shroud');
        modalShroud.addEventListener('click', (e) => {e.stopPropagation(); this.removeModal(modalShroud) });
        let modal = document.createElement("div");
        modal.setAttribute('class', 'modal');
        let close = document.createElement('button');
        let content = document.createElement('div');
        content.setAttribute('class', 'modal-content text-center');
        content.appendChild(modalContent);

        close.setAttribute('class', 'modal-close');
        close.addEventListener('click', (e) => {e.stopPropagation(); this.removeModal(modalShroud) });
        close.innerHTML = '×';

        modal.appendChild(close);
        modal.appendChild(content);
        modalShroud.appendChild(modal);

        return modalShroud;
    }

    removeModal(modal)
    {
        document.body.classList.remove('no-scroll');
        window.scrollTo(0, this.scrollPos);
        document.body.removeChild(modal);
    }

    initContainer(container)
    {
        let containerData = {
            'cabinName': container.getAttribute(this.attrNames.cabinName),
            'deckName': container.getAttribute(this.attrNames.deckName),
            'deckCode':  container.getAttribute(this.attrNames.deckCode),
            'colour':  container.getAttribute(this.attrNames.colour),
            'textColour':  container.getAttribute(this.attrNames.textColour),
            'price':  container.getAttribute(this.attrNames.price),
            'image':  container.getAttribute(this.attrNames.image)
        };

        container.addEventListener('click', (e) => {
            e.preventDefault();
            this.scrollPos = window.scrollY;
            document.body.classList.add('no-scroll');
            document.body.style.top = `-${this.scrollPos}px`;

            let contentContainer = document.createElement('div');
            contentContainer.innerHTML = `<h2> ${containerData.deckName}</h2><p><span class="cabin-code" style="color: ${containerData.textColour}; background-color: ${containerData.colour};">${containerData.deckCode}</span> ${containerData.cabinName}</p> <hr class="black-divider"><div class="imageHolder"><img src="${containerData.image}"></div> </div>`;
            document.body.insertBefore(this.createModal(contentContainer), document.body.childNodes[0]);

        });
    }

    blackOrWhite(hexcolor) {
        var r = parseInt(hexcolor.substr(0, 2), 16);
        var g = parseInt(hexcolor.substr(2, 2), 16);
        var b = parseInt(hexcolor.substr(4, 2), 16);
        var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return (yiq >= 128) ? 'black' : 'white';
    }
}
